import api from './axios';

export const getClientsApi   = (params)     => api.get('/clients', { params });
export const getClientApi    = (id)         => api.get(`/clients/${id}`);
export const createClientApi = (data)       => api.post('/clients', data);
export const updateClientApi = (id, data)   => api.put(`/clients/${id}`, data);
export const deleteClientApi = (id)         => api.delete(`/clients/${id}`);

export const uploadFiles = (clientId, formData) =>
  api.post(`/clients/${clientId}/files`, formData);

export const getFilesByLink = (clientId, linkedTo, linkedId) =>
  api.get(`/clients/${clientId}/files/by-link`, {
    params: { linkedTo, linkedId }
  });